import { Nav, NavItem, Popover, PopoverBody } from "reactstrap";

//App

import { MoreActionsMenuProps } from "../../../types";
import useMoreActionsMenuStyles from "./styles";
import { ViewIcon } from "../Icons";

const MoreActionsMenu = ({
    isOpen,
    target,
    viewIconText,
    viewIconPendingText,
    children,
    toggle,
    onViewClick,
}: MoreActionsMenuProps) => {
    const moreActionMenuStyles = useMoreActionsMenuStyles();

    return (
        <Popover
            placement="left-start"
            isOpen={isOpen}
            target={target}
            hideArrow={true}
            toggle={toggle}
            trigger="legacy"
        >
            <PopoverBody className="px-3 pt-3 pb-2">
                <Nav vertical>
                    {onViewClick && (
                        <NavItem style={moreActionMenuStyles.navItem} onClick={onViewClick}>
                            <ViewIcon iconText={viewIconText} pendingText={viewIconPendingText} />
                        </NavItem>
                    )}
                    {children}
                </Nav>
            </PopoverBody>
        </Popover>
    );
};

export default MoreActionsMenu;
